import React, { useState, useCallback, useContext } from 'react';
import { Button, Form, Toast } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import UserService from '#/services/UserService';
import { useForm, Controller } from 'react-hook-form';
import { UserContext } from '../App';
import { useNavigate } from 'react-router-dom';
import { SpinnerView } from './SpinnerView';

type MessageData = {
  type: string;
  message: string;
};

function Signup(props: { admin: boolean }) {
  const ctx = useContext(UserContext);
  const { control, handleSubmit, reset, formState } = useForm();
  const service = new UserService(ctx.userInfo);
  const navigate = useNavigate();
  const [toast, setToast] = useState<MessageData>({
    message: '',
    type: '',
  });

  const onSubmit = useCallback((values: any) => {
    service
      .signUp(values.email, props.admin ? 'admin' : 'user')
      .then(
        (_) => {
          setToast({ message: '招待メールを送信しました', type: 'normal' });
        },
        (err) => {
          if (err.response && err.response.status === 401) {
            navigate(0);
          } else {
            setToast({ message: 'エラーが発生しました', type: 'error' });
          }
        }
      )
      .finally(() => reset());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group controlId={'email'}>
          <Form.Label>メールアドレス</Form.Label>
          <Controller
            control={control}
            name="email"
            render={({ field: { onChange, value, ref } }) => (
              <Form.Control
                type="email"
                placeholder="メールアドレス"
                ref={ref}
                value={value || ''}
                onChange={onChange}
              />
            )}
          />
        </Form.Group>
        <Link to="">規約</Link>
        <p>新規登録説明文</p>
        <Controller
          control={control}
          name="submit"
          render={({ field: { ref } }) => (
            <Button type="submit" disabled={formState.isSubmitted}>
              {formState.isSubmitted ? (
                <SpinnerView size="sm" />
              ) : (
                '確認メールを送信'
              )}
            </Button>
          )}
        />
      </Form>
      <Toast
        autohide
        delay={3000}
        onClose={() => setToast({ message: '', type: '' })}
        show={toast.message.length > 0}
      >
        <Toast.Header>{toast.type === 'error' ? 'エラー' : ''}</Toast.Header>
        <Toast.Body>{toast.message}</Toast.Body>
      </Toast>
    </>
  );
}

export default Signup;
